export default "__VITE_ASSET__CitMN2P$__"